import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet, faCreditCard, faUser, faUsers, faCircleNotch, faArrowRight} from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate, Link, useLocation } from 'react-router-dom'

function Enrollment() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [disable, setDisable] = useState(true);
  const [employer_id, setEmployer_id] = useState(state?.employer_id ?? localStorage.getItem('user.employer_id') ?? '');
  const [age, setAge] = useState(state?.age ?? localStorage.getItem('user.age') ?? '');
  const [email, setEmail] = useState(localStorage.getItem('user.email') ?? '');
  const [userDetails, setUserDetails] = useState([]);
  useEffect(() => {
    if(!email){
        navigate('/login', { replace: true });
    }else{
        setLoading(false)
    }
  }, [email]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/login.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchuser1: true, email: email})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success" && data.user) {
            setUserDetails(data.user);
            setLoading(false);
        } else {
            setLoading(true);
        }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }, [email]);
  useEffect(() => {
    if(employer_id && email && age){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [email, employer_id, age]);

  if (loading || !userDetails || typeof userDetails !== 'object' || Object.keys(userDetails).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
    <div><Toaster/></div>
    <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
        Back to homepage
        </Link>
    </header>
    <main>
        <div className="container mt-5">
            <div className="row">
                <div className="col-lg-8 offset-lg-2 mb-5">
                    <h5 className="mb-0" style={{fontWeight:'900'}}>401(k) Enrollment</h5>
                    <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                    <Link to="/enrollment" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                        <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Personal</p>
                    </Link>
                    <div style={{height:'3px',maxWidth:'200px',width:'100%', backgroundColor:'#ffffff0c',}}></div>
                    <Link to="/enrollment1" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                        <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Contributions</p>
                    </Link>
                    <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                    <Link to="/enrollment2" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                        <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Investment</p>
                    </Link>
                    <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                    <Link to="/enrollment3" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                        <FontAwesomeIcon icon={faUsers} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Beneficiary</p>
                    </Link>
                    <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                    <Link to="/enrollment4" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                        <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review</p>
                    </Link>
                    </div>
                    <div className="mycard p-3 mt-4">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Fullname</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="Fullname"
                                        value={userDetails?.fullname}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Email Address</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="Email address"
                                        value={userDetails?.email}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Employee ID</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="Employee ID"
                                        value={employer_id}
                                        onChange={(e) => setEmployer_id(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Starting Age</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="30"
                                        value={age}
                                        onChange={(e) => setAge(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end">
                        {disable ? (
                            <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                        ) : (
                            <Link to="/enrollment1" state={{employer_id:employer_id, email:email, age:age}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => { 
                                localStorage.setItem('user.employer_id', employer_id);
                                localStorage.setItem('user.age', age);
                            }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </div>
  )
}

export default Enrollment